import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import { useUser } from './UserContext';


// Taking EDA Config structure from OG EDA notebook: https://github.com/MightyHive/matched_markets_ui/blob/main/notebooks/EDA/how_to_eda.ipynb

export interface ChatModel {
  prevResponseId: string
}

export interface HypeModel {
    vectorStore: {
      vectorStoreId: string | null
      vectorStoreName: string
      vectorStoreFiles: string[]
    }
    loading: boolean
    chat?: ChatModel
    updateChat?: (responseId: string) => void
}

export const defaultHypeState: HypeModel = {
  vectorStore: {
    vectorStoreId: null,
    vectorStoreName: "",
    vectorStoreFiles: [],
  },
  loading: false,
};

type HypeResponse = {
    vector_store_id: string | null
    vector_store_name: string
    file_names: string[]
}

const defaultHype: HypeModel = {
  vectorStore: {
    vectorStoreId: null,
    vectorStoreName: "",
    vectorStoreFiles: [],
  },
  loading: false,
};

const HypeContext = createContext<HypeModel>(defaultHype);

export function useHype(): HypeModel {
  return useContext(HypeContext);
}

export function HypeProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const [hype, setHype] = useState<HypeModel>(defaultHype);
  const navigate = useNavigate();
  const { isPoweruser } = useUser();

  const updateChat = (responseId: string) => {
    setHype((prev) => ({
      ...prev,
      chat:{
        prevResponseId: responseId,
      },
    }));
  }

  useEffect(() => {
    if (!isPoweruser) return;
    apiFetch('/api/hype/create')
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then((data: {data: HypeResponse}) => {
        setHype((prev) => ({
          ...prev,
          loading: false,
          vectorStore: {
            ...prev.vectorStore,
            vectorStoreId: data.data.vector_store_id ?? null,
            vectorStoreName: data.data.vector_store_name ?? "",
          },
        }));
      })
      .catch((e) => {
        console.error(e)
      });
  }, [navigate, isPoweruser]);

  const contextValue: HypeModel = {
    ...hype,
    updateChat,
  };

  return (
    <HypeContext.Provider value={contextValue}>
      {children}
    </HypeContext.Provider>
  );
}